import Vue from 'vue';
import router from '../router'
import axios from 'axios'
import store from '@/store/index.js'
import { getToken } from '@/utils/user.js'
import { delToken } from '@/utils/user.js'

const service = axios.create({
  baseURL: window.location.origin+'/project/afc_api/index.php',
  //baseURL: '/host/afc_api/index.php',
  timeout: 30000
})

// request拦截器
service.interceptors.request.use(
  config => {
    config.headers['token'] = store.getters['user/getToken'] || getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    /**
     * code为非20000是抛错 可结合自己业务进行修改
     */
    const res = response.data
    if (res.code !== 2000) {
      // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
      if (res.code === 5001) {
        delToken();
        Vue.swal({
          title: '账号未登录或已离线，请登录',
          type: 'warning',
          timer: 2000,
          showConfirmButton: true,
          onClose(){
            router.push({path: '/login'});
          }
        })
        /*Message({
          message: '账号未登录或已离线，请登录',
          type: 'warning',
          duration: 3 * 1000,
          position: 'center'
        })*/
        return Promise.reject('error')
      }
      /*Message({
        message: '错误信息: '+res.msg,
        type: 'error',
        duration: 3 * 1000,
        position: 'center'
      })*/
      Vue.swal({
        title: '错误信息: &nbsp;&nbsp;'+res.msg,
        type: 'error',
        timer: 3000,
        showConfirmButton: true,
      })
      return Promise.reject('error')
    } else {
      return response.data
    }
  },
  error => {
    console.log('网络错误：' + error) // for debug
    Vue.swal({
      title: '网络错误： &nbsp;&nbsp;'+error.message,
      type: 'error',
      timer: 3000,
      showConfirmButton: true,
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/api/request.js